module.exports = __webpack_public_path__ + "static/media/toolbar_go_death_s.93b2c259.png";